import { render } from "./attention-company.vue?vue&type=template&id=7fe11eac&scoped=true"
import script from "./attention-company.vue?vue&type=script&lang=js"
export * from "./attention-company.vue?vue&type=script&lang=js"

import "./attention-company.vue?vue&type=style&index=0&id=7fe11eac&scoped=true&lang=css"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fe11eac"]])

export default __exports__